(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9972],{

/***/ 39972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RecommendationsList": function() { return /* binding */ RecommendationsList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _RecommendationItem_RecommendationItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82039);
/* harmony import */ var _RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60815);
/* harmony import */ var _RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5__);






var RecommendationsList = function(param) {
    var _items = param.items, items = _items === void 0 ? [] : _items, _hideHeading = param.hideHeading, hideHeading = _hideHeading === void 0 ? false : _hideHeading, listView = param.listView, props = param.props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5___default().listContainer)),
        children: [
            !hideHeading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5___default().listTitle), "text-3xl font-fragment sm:mb-10 mb-20"),
                children: "More from BusinessClass.com"
            }),
            !listView && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5___default().itemBlock), items.length > 1 && "lg:grid lg:grid-cols-2 lg:gap-x-8"),
                children: !!items.length && items.map(function(item, i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(items.length > 1 && i === items.length - 1 && (_RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5___default().halfWidth), (_RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item)),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RecommendationItem_RecommendationItem__WEBPACK_IMPORTED_MODULE_2__/* .RecommendationItem */ .A, {
                            item: item
                        }, item.title)
                    }, item.title);
                })
            }),
            listView && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5___default().itemBlock), items.length > 1 && "flex flex-col items-center"),
                children: !!items.length && items.map(function(item) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item)),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RecommendationItem_RecommendationItem__WEBPACK_IMPORTED_MODULE_2__/* .RecommendationItem */ .A, {
                            item: item
                        }, item.title)
                    }, item.title);
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (RecommendationsList);


/***/ }),

/***/ 60815:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"RecommendationsList_listContainer__zOMv6","listTitle":"RecommendationsList_listTitle__pJJNc","halfWidth":"RecommendationsList_halfWidth__ejpzI"};

/***/ })

}]);